export const reportsKeys = {
  all: ['reports'] as const,
  metadataList: () => [...reportsKeys.all, 'metadataList'] as const,
  metabaseDashboardUrl: (dashboardId: string, accountId: string) =>
    [
      ...reportsKeys.all,
      'metabaseDashboardUrl',
      dashboardId,
      accountId,
    ] as const,
  hasCmCampaigns: (accountId: string) =>
    [...reportsKeys.all, 'hasCmCampaigns', accountId] as const,
}
